// extracted by mini-css-extract-plugin
module.exports = {"box":"catpost-link-module--box--sw3KE","name":"catpost-link-module--name--3fw18"};